import { Component, OnInit } from '@angular/core';
import { IMAGE, BANNER, CATEGORY, SUBCATEGORY } from 'src/app/config';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-subcategory',
    templateUrl: './subcategory.component.html',
    styleUrls: ['./subcategory.component.css'],
    
})
export class SubcategoryComponent implements OnInit {
  data:any;
  category: any;
  img_url=IMAGE;
  callshadow:any;
  id:any;
  mid:any
  Banner: any;
  constructor(private api: ApiService, private route: ActivatedRoute,private router: Router) { 
    this.route.params.subscribe(
      params=>{
        this.api.Post(SUBCATEGORY, {category_id: params.id} ).then(data  => {
          this.data = data['data'].filter(x => x.status == 1);
          
          this.api.Post(CATEGORY, {} ).then(data  => {
            let result = data['data'].find(x => x.id == params.id);
            this.category = result;
            console.log(this.category);
         }).catch(d=>{console.log(d);});
        });
      });
  }

  go(value){
      this.router.navigate(['subsub', value]);
  }

  ngOnInit(): void {
  }

}
